function getTodayZeroTime() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today.getTime();
}
const ONE_DAY = 24 * 60 * 60 * 1000;
const TODAY_ZERO = getTodayZeroTime();
export const dateCalcMap = {
    end: {
        is: function (input) {
            return TODAY_ZERO <= input;
        },
        '=': function (input, range) {
            return TODAY_ZERO + range * ONE_DAY === input;
        },
        '>': function (input, range) {
            return TODAY_ZERO + range * ONE_DAY < input;
        },
        '<': function (input, range) {
            return TODAY_ZERO + range * ONE_DAY > input;
        },
        '>=': function (input, range) {
            return TODAY_ZERO + range * ONE_DAY <= input;
        },
        '<=': function (input, range) {
            return TODAY_ZERO + range * ONE_DAY >= input;
        },
    },
    start: {
        is: function (input) {
            return TODAY_ZERO >= input;
        },
        '=': function (input, range) {
            return TODAY_ZERO - range * ONE_DAY === input;
        },
        '>': function (input, range) {
            return TODAY_ZERO - range * ONE_DAY > input;
        },
        '<': function (input, range) {
            return TODAY_ZERO - range * ONE_DAY < input;
        },
        '>=': function (input, range) {
            return TODAY_ZERO - range * ONE_DAY >= input;
        },
        '<=': function (input, range) {
            return TODAY_ZERO - range * ONE_DAY <= input;
        },
    },
};